"use strict";

var novicell = novicell || {};
novicell.overlay = novicell.overlay || {};

// Waiting for the DOM to load
document.addEventListener('DOMContentLoaded', function () {
    var videoOverlayTriggers = document.querySelectorAll('.js-overlay-trigger');

    for (var i = 0; i < videoOverlayTriggers.length; i++) {
        videoOverlayTriggers[i].addEventListener('click', function(e){
            e.preventDefault();

            var currentTrigger = e.target;

            novicell.overlay.create({
                'selector': '#js-overlay-content',
                'class': 'selector-overlay',
            });
        });
    }
});